<template>
  <div></div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  components: {},
  name: "EmployeeDetailMain",
  data() {
    return {
      employeeId: null,
      event: null,
      open: false,
    };
  },
  computed: {
      ...mapGetters(['employeeById', 'employeeMap', 'storeSettings', 'isSuperUser', 'anonMode'])
  },
  watch: {
    
    employeeMap(newVal, oldVal){
        if(this.employeeId){
            let employee = this.employeeById(this.employeeId);
            if(employee){
                this.OpenEmployeeDataViewPopup(this.event, employee);
            }
        }
    }
  },
 
  created() {},
  mounted() {},
  updated() {},
  destroyed() {},
  methods: {
    Init(state){
        if (
          state != null &&
          state.employeeId != null &&
          state.event != null
        ) {
            
            this.open = false;
            this.employeeId = state.employeeId;
            this.event = state.event;
            let employee = this.employeeById(this.employeeId);
            if(employee){
                this.OpenEmployeeDataViewPopup(state.event, employee);
            } else {
                this.$helpers.GetActiveEmployeeMap(true, false, this.storeSettings.hideDeactivatedEmployees).then((result) => {console.log("employeeMap refreshed");}).catch((error) => this.$helpers.error("Laden der Mitarbeiter fehlgeschlagen", error));
            } 
           
        }
    },
    OpenEmployeeDataViewPopup($event, employee) {
      if(!this.open){
        let view = this;
        let target = $event.currentTarget;
        let dtabs = [];
        dtabs.push(
            {
              tabHeader: this.$t('pages.employeeContext.skills'),
              type: "employeedetailskills",
              eventProp: null,
              componentState: { employee: employee },
              customEventName: null,
              customEventHandler: data => {}
            },
            {
              tabHeader: this.$t('pages.employeeContext.availabilities'),
              type: "employeedetailavailabilities",
              eventProp: null,
              componentState: { employee: employee },
              customEventName: null,
              customEventHandler: data => {}
            },
            {
              tabHeader: this.$t('pages.employeeContext.absences'),
              type: "employeedetailpreferences",
              eventProp: null,
              componentState: { employee: employee },
              customEventName: null,
              customEventHandler: data => {}
            });
        if(view.storeSettings && !view.storeSettings.simpleMode){
          dtabs.push({
              tabHeader: this.$tc('pages.employeeContext.planning', 0),
              type: "employeedetailtype",
              eventProp: null,
              componentState: { employee: employee, t0: this.t0},
              customEventName: null,
              customEventHandler: data => {}
            },
            {
              tabHeader: this.$t('pages.employeeContext.recreation'),
              type: "employeedetailrules",
              eventProp: null,
              componentState: { employee: employee },
              customEventName: null,
              customEventHandler: data => {}
            });
          
        }
        if(this.isSuperUser){
          dtabs.push(
            {
              tabHeader: this.$t('shift.plan.punchTimes'),
              type: "employeedetailactualshifts",
              eventProp: null,
              componentState: { employee: employee },
              customEventName: null,
              customEventHandler: data => {}
            },
          ); 
        }
        

        let headerStr = this.anonMode ? this.$t('roster.view.anonymousEmployee') : employee.lastName+" "+employee.firstName;
        if(employee.personnelId && !this.anonMode){
          headerStr += " (" + employee.personnelId + ")"
        }
         
        this.$helpers.OpenPopup({
          elRelative: target,
          tabs: dtabs,
          header: headerStr,
          smallheader: true,
          containerstyle: "padding: 40px 45px !important; width: 1000px; height: calc(100vh - 120px);",
          width: '1000px',
          expanded: true,
          centered: true
        });
        this.open = true;
      }
      
    }
  }
};
</script>
